import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@heroui/react";

import { AppModalProps } from "./AppModal.types";

export const AppModal: React.FC<AppModalProps> = ({
  id = "app-modal",
  isOpen,
  onClose,
  onOpenChange,
  size = "lg",
  title,
  subtitle,
  children,
  footer,
  hideCloseButton = false,
}) => {
  return (
    <Modal
      backdrop="blur"
      classNames={{
        closeButton: "mr-[20px] mt-[10px]",
      }}
      hideCloseButton={true}
      id={id}
      isOpen={isOpen}
      placement="center"
      size={size}
      onClose={onClose}
      onOpenChange={onOpenChange}
    >
      <ModalContent
        className="bg-gray-800 p-[1px] !shadow-none !outline-none !ring-0 data-[focus-visible=true]:!outline-none data-[focus-visible=true]:!ring-0"
        id={`${id}-content`}
        style={{
          borderRadius: 0,
          clipPath: "polygon(0 0, calc(100% - 35px) 0, 100% 35px, 100% 100%, 0 100%)",
        }}
      >
        {() => (
          <div
            className="relative h-full w-full bg-[#0F0F0F]"
            id={`${id}-surface`}
            style={{
              clipPath: "polygon(0 0, calc(100% - 35px) 0, 100% 35px, 100% 100%, 0 100%)",
            }}
          >
            {!hideCloseButton && (
              <button
                className="absolute -right-[25px] top-[13px] z-50 flex h-[24px] w-[100px] rotate-45 transform items-center justify-center bg-white/5 text-gray-400 backdrop-blur-sm transition-all hover:bg-red-500 hover:text-white"
                id={`${id}-close-button`}
                onClick={onClose}
              >
                <div className="-rotate-45 transform">
                  <svg
                    fill="none"
                    height="16"
                    id={`${id}-close-icon`}
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.5"
                    viewBox="0 0 24 24"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M18 6 6 18" />
                    <path d="m6 6 12 12" />
                  </svg>
                </div>
              </button>
            )}

            {(title || subtitle) && (
              <ModalHeader className="pr-16" id={`${id}-header`}>
                <div className="flex flex-col gap-1" id={`${id}-header-text`}>
                  {title && (
                    <h3 className="text-xl font-bold text-white" id={`${id}-title`}>
                      {title}
                    </h3>
                  )}
                  {subtitle && (
                    <p className="text-sm font-normal text-gray-400" id={`${id}-subtitle`}>
                      {subtitle}
                    </p>
                  )}
                </div>
              </ModalHeader>
            )}
            <ModalBody className="pb-6" id={`${id}-body`}>
              {children}
            </ModalBody>
            {footer && <ModalFooter id={`${id}-footer`}>{footer}</ModalFooter>}
          </div>
        )}
      </ModalContent>
    </Modal>
  );
};
